
export { default as useClickOutsideMultiElement } from "./useClickOutsideElement.hook"